<template>
  <swiper :options="swiperOption">
    <swiper-slide class="swiperL" v-for="(item, index) in list" :key="index">
      <img :src="item.banner_img" :alt="item.banner_name">
    </swiper-slide>
    <div class="swiper-pagination" v-show="list.length>1" slot="pagination"></div>
  </swiper>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    list: Array
  },
  data () {
    return {
      swiperOption: {
        pagination: '.swiper-pagination',
        loop: false,
        autoplay: 2000
      }
    }
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
img
  width 100%
  height auto
  object-fit contain
.swiperL
  position relative
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue